import { render, staticRenderFns } from "./RequiredCRFBanner.vue?vue&type=template&id=5574c8cc&"
import script from "./RequiredCRFBanner.vue?vue&type=script&lang=js&"
export * from "./RequiredCRFBanner.vue?vue&type=script&lang=js&"
import style0 from "./RequiredCRFBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports